/*
 * @description: 应用的一些配置项
 * @author:
 * @since:
 * @version: 1.0
 */
import envVariables from '@/env-variables'

export default {
  cookieKeyNames: {
    /**
    * @type {string}
    * @description 是否已登录的cookie中key名称
    */
    AUTH_KEY_NAME: 'Authed',

    /**
    * @type {string}
    * @description 如果有token，token在cookie中保存的key的名称
    */
    AUTH_TOKEN_KEY_NAME: 'Admin-Token'
  },
  // 可以不登录即可访问的页面
  whiteListRouters: ['/login', '/auth-redirect'],
  
  /**
  * @type {string}
  * @description 登录页面地址，跟router中定义的保持一致
  */
  loginPath: '/login',

  /**
  * @type {string}
  * @description index默认地址
  */
  indexPath: '/',

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description 是否将错误日志存储到vuex中
   * 默认production env
   * 如果开始时使用可以 ['production', 'development']
   */
  errorLog: 'production',
  
  /**
   * axios通用请求实例定义列表
   * 可定义多个，通过name从framework/utils/request获取
   * 支持的格式为{code, result, reason}
   * 其他形式的请自行自定义，或调用时直接使用axios
   */
  requests: [
    {
      name: 'common',
      // baseApi为key，列表中不能重复
      baseApi: envVariables.baseApi,
      timeout: 300000,
      crossDomain: true,
      /**
       * 请求配置，一般如何需要token可以设置，其他基本不用设置
       *
       * @param {Object} config     axios的config对象
       */
      requestConfig(config) {
        // config.headers['X-Token'] = getToken()
        return config
      }
      /**
       * 请求成功时的回调
       *
       * @param {Object} response   返回结果
       */
      // success (response) {
      // 调用默认实现，也可不定义，不定义即为默认实现
      // 默认实现会把code !== 200的都当成失败来出来，code为401的会退出登录并跳转到登录页面

      // },
      /**
       * 请求失败的回调
       *
       * @param {Object} error      错误信息
       */
      // fail (error) {
      // 调用默认实现，也可不定义，不定义即为默认实现
      // 默认实现如果是服务返回的错误，会在页面显示reason字段作为错误提示
      // 自定义处理时，如果要获取服务器返回的错误结果时，通过error.response获得

      // }
    }
    // 如有需要可继续定义
  ]
}
